<template>
  <div
    id="moveParkInfo"
    class="detail-pop"
    :style="{ width: popWidth, height: popHeight }"
  >
    <div class="detail-pop-header">
      <div class="detail-pop-header-title">
        <div :class="type == 1 ? 'active-border' : ''" @click="type = 1">
          招商信息
        </div>
        <div :class="type == 2 ? 'active-border' : ''" @click="type = 2">
          园区详情
        </div>
      </div>
      <div class="detail-pop-header-close" @click="onClose">
        <i class="el-icon-close" style="font-size: 20px"></i>
      </div>
      <div
        class="detail-pop-header-rank"
        @mousedown.stop="dragDiv($event)"
        @mouseup.stop="clearEvent($event)"
      >
        <!-- <i class="el-icon-rank"></i> -->
      </div>
    </div>
    <div class="detail-pop-center scrollbar-definition" v-show="type == 1">
      <div class="detail-pop-content">
        <div class="detail-pop-content-box">
          <el-row :gutter="20">
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="9">联系人员：</el-col>
              <el-col :span="15"> {{ info.person }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="8">联系电话:</el-col>
              <el-col :span="16">{{ info.phone }}</el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">招商政策:</el-col>
              <el-col
                :span="20"
                class="detail-pop-content-box-col-c"
                v-html="info.investmentPolicy"
              ></el-col>
            </el-col>
            <!-- <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">项目情况:</el-col>
              <el-col
                :span="20"
                class="detail-pop-content-box-col-c"
                v-html="info.projectSituation"
              ></el-col>
            </el-col> -->
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">招商需求:</el-col>
              <el-col
                :span="20"
                class="detail-pop-content-box-col-c"
                v-html="info.investmentDemand"
              ></el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">产业链:</el-col>
              <el-col
                :span="20"
                class="detail-pop-content-box-col-c"
                v-html="info.industrialChain"
              ></el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">人才情况:</el-col>
              <el-col
                :span="20"
                class="detail-pop-content-box-col-c"
                v-html="info.talentSituation"
              ></el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">用地情况:</el-col>
              <el-col
                :span="20"
                class="detail-pop-content-box-col-c"
                v-html="info.landSituation"
              ></el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">宣传图片</el-col>
              <el-col :span="20">
                <div class="img-list-box">
                  <div
                    class="img-list"
                    v-for="(item, index) in info.pronounceImages"
                    :key="index"
                    @click="handleLook(info.pronounceImages, index)"
                  >
                    <img :src="item.url" alt="" />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">相关附件:</el-col>
              <el-col :span="20">
                <div class="img-list-box">
                  <div
                    class="img-list"
                    v-for="(item, index) in info.attachmentFiles"
                    :key="index"
                    v-show="info.attachmentFiles.length > 0"
                    @click="lookPdf(item)"
                  >
                    <img
                      src="../../../assets/images/common/pdf.png"
                      v-show="item.suffix == 'pdf'"
                      alt=""
                    />
                    <img
                      src="../../../assets/images/common/word.png"
                      v-show="item.suffix == 'docx' || item.suffix == 'doc'"
                      alt=""
                    />
                    <img
                      src="../../../assets/images/common/excel.png"
                      v-show="item.suffix == 'xlsx' || item.suffix == 'xls'"
                      alt=""
                    />
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
              <!-- <el-col :span="20">
                <div
                  class="file-list-box"
                  v-for="(item, index) in info.attachmentFiles"
                  :key="index"
                  v-show="info.attachmentFiles.length > 0"
                >
                  <div class="list-li">
                    <div class="mouse-s">
                      <i class="iconfont icon-geshi_shipinmp"></i>
                      {{ item.fileTitle }}
                    </div>
                    <div @click="lookPdf(item)">
                      查看/下载
                    </div>
                  </div>
                </div>
              </el-col> -->
            </el-col>
            <el-col :span="24" class="detail-pop-content-box-col">
              <el-col :span="4">宣传视频:</el-col>
              <el-col :span="20">
                <div class="img-list-box">
                  <div
                    class="img-list1"
                    v-for="(item, index) in info.pronounceVideos"
                    :key="index"
                  >
                    <img :src="item.thumbnailSrc" alt="" />
                    <div class="mask">
                      <div
                        class="iconfont icon-bofang"
                        @click="playVideos(item)"
                      ></div>
                    </div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="item.fileTitle"
                      placement="top-start"
                    >
                      <div class="img-span">{{ item.fileTitle }}</div>
                    </el-tooltip>
                  </div>
                </div>
              </el-col>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="detail-pop-center scrollbar-definition" v-show="type == 2">
      <div class="detail-pop-content">
        <div class="detail-pop-content-title">
          <div class="yuan"></div>
          批准范围
        </div>
        <div class="detail-pop-content-box">
          <el-row :gutter="20">
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">开发区名称：</el-col>
              <el-col :span="14"> {{ info.name }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">开发区代码：</el-col>
              <el-col :span="14">{{ info.parkCode }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">行政区划:</el-col>
              <el-col :span="14">{{ info.countyName }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">设立时间:</el-col>
              <el-col :span="14">{{ info.setTime }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">园区级别:</el-col>
              <el-col :span="14">{{ info.parkLevelName }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">审批类型:</el-col>
              <el-col :span="14">{{ info.approvalType }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">园区评价类:</el-col>
              <el-col :span="14">{{ info.parkType }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">园区联系方式:</el-col>
              <el-col :span="14">{{ info.parkPhone }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">主导产业:</el-col>
              <el-col :span="14">{{ info.leadingIndustry }}</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">园区面积:</el-col>
              <el-col :span="14">{{ info.developArea }}亩</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">规划建设用地面积:</el-col>
              <el-col :span="14">{{ info.planArea }}亩</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">二、三产业税收总额:</el-col>
              <el-col :span="14">{{ info.secondThirdTotal }}万元</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">已批准征收土地面积:</el-col>
              <el-col :span="14">{{ info.levyArea }}亩</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">工业（物流）企业固定资产投资额:</el-col>
              <el-col :span="14">{{ info.industrialFixed }}万元</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">已批准转用土地面积:</el-col>
              <el-col :span="14">{{ info.diversionArea }}亩</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">工业（物流）企业总收入:</el-col>
              <el-col :span="14">{{ info.industrialTotal }}万元</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">批而未供土地面积:</el-col>
              <el-col :span="14">{{ info.approvalNotProvide }}亩</el-col>
            </el-col>
            <el-col :span="12" class="detail-pop-content-box-col">
              <el-col :span="10">工业（物流）企业税收总额:</el-col>
              <el-col :span="14">{{ info.industrialRevenue }}万元</el-col>
            </el-col>
          </el-row>
        </div>
      </div>
      <div>
        <div class="detail-pop-content">
          <div class="detail-pop-content-title">
            <div class="yuan"></div>
            实际管理范围
          </div>
          <div class="detail-pop-content-box">
            <el-row :gutter="20">
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">产业园名称:</el-col>
                <el-col :span="14">{{ info.name }} </el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">产业园代码：</el-col>
                <el-col :span="14">{{ info.parkCode }}</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">行政区划:</el-col>
                <el-col :span="14">{{ info.countyName }}</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">设立时间:</el-col>
                <el-col :span="14">{{ info.setTimeActual }}</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">园区联系方式:</el-col>
                <el-col :span="14">{{ info.parkPhoneActual }}</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">实际管理面积:</el-col>
                <el-col :span="14">{{ info.actualAreaActual }}亩</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">规划建设用地面积:</el-col>
                <el-col :span="14">{{ info.planAreaActual }}亩</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">已批准征收土地面积:</el-col>
                <el-col :span="14">{{ info.levyAreaActual }}亩</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">已批准转用土地面积:</el-col>
                <el-col :span="14">{{ info.diversionAreaActual }}亩</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">批而未供土地面积:</el-col>
                <el-col :span="14"
                  >{{ info.approvalNotProvideActual }}亩</el-col
                >
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">工业（物流）企业固定资产投资额:</el-col>
                <el-col :span="14">{{ info.industrialFixedActual }}万元</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">二，三产业税收总额:</el-col>
                <el-col :span="14"
                  >{{ info.secondThirdTotalActual }}万元</el-col
                >
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">工业（物流）企业总收入:</el-col>
                <el-col :span="14">{{ info.industrialTotalActual }}万元</el-col>
              </el-col>
              <el-col :span="12" class="detail-pop-content-box-col">
                <el-col :span="10">工业（物流）企业税收总额:</el-col>
                <el-col :span="14"
                  >{{ info.industrialRevenueActual }}万元</el-col
                >
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <video-image
      :visible="dialogVisible"
      :imageSrc="dialogImageUrl"
      @onCloseImage="onCloseImage"
    ></video-image>
    <video-dialog
      :visible="dialogVisibleVideo"
      :videoSrc="videoSrc"
      :videoTitle="videoTitle"
      @onCloseVideo="onCloseVideo"
    ></video-dialog>

    <el-image-viewer
      :url-list="srcList"
      :initial-index="viewerIndex"
      :on-close="closeViewer"
      v-if="viewerShow"
      style="z-index: 9999"
    ></el-image-viewer>
  </div>
</template>
<script>
import VideoDialog from "@/components/currency/videoDialog";
import VideoImage from "@/components/currency/videoImage";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  name: "park-detail-pop",
  components: {
    VideoDialog,
    VideoImage,
    ElImageViewer,
  },
  props: {
    title: {
      type: String,
      default: "标题",
    },
    popHeight: {
      type: String,
      default: "600px",
    },
    popWidth: {
      type: String,
      default: "560px",
    },
    colProportion: {
      type: Number,
      default: 12,
    },
    labelProportion: {
      type: Number,
      default: 10,
    },
    valueProportion: {
      type: Number,
      default: 14,
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      type: 1,
      imgList: [],
      dialogVisibleVideo: false,
      videoSrc: "",
      videoTitle: "",
      dialogImageUrl: "",
      dialogVisible: false,
      viewerShow: false,
      srcList: [],
      viewerIndex: 0,
    };
  },
  methods: {
    // 区块拖动
    dragDiv(el, index) {
      let osmall = document.getElementById("moveParkInfo");

      // 用于保存小的div拖拽前的坐标
      osmall.startX = el.clientX - osmall.offsetLeft;
      osmall.startY = el.clientY - osmall.offsetTop;
      console.log(osmall.startX, osmall.startY, "osmall");
      document.onmousemove = (e) => {
        let left, top;
        left = e.clientX - osmall.startX;
        top = e.clientY - osmall.startY;
        osmall.style.left = left + "px";
        osmall.style.top = top + "px";
        // coordinate.x = left;
        // coordinate.y = top;
        if (left <= 0) {
          osmall.style.left = 0 + "px";
          // coordinate.x = 0;
        }
        if (top <= 0) {
          osmall.style.top = 0 + "px";
          // coordinate.y = 0;
        }
      };
    },
    // 清除鼠标事件
    clearEvent() {
      document.onmousemove = null;
      document.onmouseup = null;
    },
    mousedownSf(el) {
      document.onselectstart = function () {
        return false;
      };
      let oDiv = el;
      console.log(oDiv.style, "oDiv.style");
      let cDiv = document.getElementById("moveParkInfo");
      console.log(cDiv, "=====");
      oDiv.onmousedown = function (e) {
        // 鼠标按下，计算当前元素距离可视区的距离
        let disX = e.clientX - oDiv.offsetLeft;
        let disY = e.clientY - oDiv.offsetTop;
        document.onmousemove = function (e) {
          // 通过事件委托，计算移动的距离
          let l = e.clientX - disX;
          let t = e.clientY - disY;
          // 移动当前元素
          console.log(oDiv.style, "oDiv.style");
          oDiv.style.width = l + "px";
          oDiv.style.height = t + "px";
        };
        document.onmouseup = function (e) {
          document.onmousemove = null;
          document.onmouseup = null;
        };
        // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
        return false;
        console.log(el, "el");
      };
    },
    onClose() {
      this.$emit("onClosePark", false);
    },
    //播放视频
    playVideos(file) {
      this.dialogVisibleVideo = true;
      this.videoSrc =
        systemConfig.imgServer + systemConfig.imgApi + file.filePath;
      this.videoTitle = file.fileTitle || "";
    },
    onCloseVideo() {
      this.dialogVisibleVideo = false;
    },
    onCloseImage() {
      this.dialogVisible = false;
    },
    lookPdf(file) {
      window.open(systemConfig.imgServer + systemConfig.imgApi + file.filePath);
    },
    //查看图片
    handleLook(list, index) {
      this.srcList = [];
      list.forEach((item) => {
        this.srcList.push(item.url);
      });
      this.viewerIndex = index;
      this.viewerShow = true;
    },
    //关闭查看大图
    closeViewer() {
      this.viewerShow = false;
    },
  },
};
</script>
<style scoped>
.detail-pop {
  background: #fff;
  border: 1px solid rgb(153, 153, 153);
  position: relative;
  resize: both;
  overflow: auto;
}

.detail-pop-header {
  color: #808080;
  font-size: 1rem;
  padding: 7px 16px;
  display: flex;
  position: relative;
  justify-content: space-between;
}
.detail-pop-header-title {
  width: 100%;
  display: flex;
  /* padding: 0 20px; */
  border-bottom: 1px solid rgb(206, 206, 206);
}
.detail-pop-header-title > div {
  margin: 0 10px;
  padding-top: 10px;
  padding-bottom: 7px;
}
.detail-pop-header-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 26px;
  height: 26px;
  /* background: rgb(89 197 222 / 62%);
  border-radius: 0 0 0 50px; */
  text-align: center;
  color: #808080;
  font-weight: 600;
  font-size: 1.45rem;
  cursor: pointer;
}
.detail-pop-header-rank {
  position: absolute;
  top: 8px;
  left: 240px;
  width: 50%;
  height: 41px;
  /* text-align: center;
  color: #808080;
  font-weight: 600;
  font-size: 0.95rem; */
  cursor: pointer;
}
.detail-pop-center {
  height: calc(100% - 55px);
  overflow: auto;
}
.detail-pop-content {
  margin: 10px 15px;
  color: #808080;
}
.detail-pop-content-title {
  padding: 2px 15px;
  /* background: #185c75; */
  color: #157cf3;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 7px;
  display: flex;
}
.active-border {
  color: #157cf3;
  border-bottom: 2px solid #157cf3;
}
.yuan {
  width: 9px;
  height: 9px;
  background: #157cf3;
  border-radius: 50%;
  margin: auto 6px auto 0;
}
.detail-pop-content-box {
  font-size: 0.8rem;
}
.detail-pop-content-box-col {
  padding: 10px 0;
  word-break: break-all;
}
::v-deep .detail-pop-content-box-col-c > p,
span {
  line-height: 22px;
  margin: 0;
  color: #363636 !important;
}
::v-deep .detail-pop-content-box-col-c > p > img {
  width: 100%;
  height: 100%;
}
.img-list {
  width: 65px;
  height: 85px;
  margin-right: 10px;
  cursor: pointer;
}
.img-list1 {
  position: relative;
  width: 65px;
  height: 85px;
  margin-right: 10px;
}
.img-list1:hover .mask {
  opacity: 1;
  cursor: default;
}
.img-list1 > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}
.mask {
  width: 65px;
  height: 65px;
  font-size: 0.95rem;
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 0;
  opacity: 0;
  background: rgba(4, 20, 41, 0.4);
  border-radius: 4px;
  line-height: 65px;
  /* padding: 24px 0; */
}
.img-span {
  font-size: 0.75rem;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.img-list > img {
  width: 100%;
  height: 65px;
  border-radius: 4px;
  overflow: hidden;
}
.img-list-box {
  display: flex;
  flex-wrap: wrap;
}
.list-li {
  margin-left: 0;
  display: flex;
  justify-content: space-between;
  padding: 5px;
}
.file-list-box :hover {
  background: #d4e3fa;
  color: #fff;
  cursor: pointer;
}
.file-list-box {
  padding-left: 0;
}
.mouse-s {
  color: #808080;
}
</style>
